import { Component, Injectable, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ContactService } from 'api-services/contact.service';
import { LicenseRenewalService } from 'api-services/license-renewal.service';
import { Validators } from 'ngx-editor';
import { Subscription } from 'rxjs';
import { RoleService } from 'services/role.service';
import { PermissionAccessType, RolePermissionType } from 'shared/constant';


@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.month + this.DELIMITER + date.day + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  selector: 'app-pii-information-popup',
  templateUrl: './pii-information-popup.component.html',
  styleUrls: ['./pii-information-popup.component.css'],
    providers: [
      { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ]
})
export class PIIInformationPopupComponent implements OnInit {
 @Input() user;
  licenseRenewalObj: any;
  isInValid: boolean = true;
  pattern = { 0: { pattern: new RegExp('\\d'), symbol: '●' } };
  isShow = true;
  submitRequestForm: FormGroup;
  subscription: Subscription[] = [];

  licenseRenewalObjList: any = [];
  today = new Date();
  minDate = {
    year: this.today.getFullYear() - 125,
    month: this.today.getMonth() + 1,
    day: this.today.getDate()
  }
  maxDate = {
    year: this.today.getFullYear(),
    month: this.today.getMonth() + 1,
    day: this.today.getDate()
  }

  isPIIEditPermittedforSSN: boolean = true;
  isPIIEditPermittedForDOB: boolean = true;
  isProfileInformationEditPermitted: boolean = true;
  isAdminUser = false;
  isAccountOnwer: boolean = false;
  loggedInUserId = Number(localStorage.getItem('userId'));
  isIndividualUser = false;
  isContactUser: boolean = false;

  constructor(public activeModal: NgbActiveModal, private roleService: RoleService, private contactService: ContactService,
    private licenseRenewalService: LicenseRenewalService, private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.isAdminUser = this.roleService.isAdminUser;
    this.isAccountOnwer = this.roleService.isTenantOwnerUser;
    this.isIndividualUser = this.roleService.isIndividualUser;
    this.isContactUser = this.roleService.isContactUser;
    
    if (this.isAccountOnwer || (this.isAdminUser && this.user.userId == this.loggedInUserId)) {
      this.isPIIEditPermittedforSSN = true;
      this.isPIIEditPermittedForDOB = true;
    }
    else {
    this.isProfileInformationEditPermitted = this.roleService.isFeatureAccessible(RolePermissionType.ProfileInformation, PermissionAccessType.Yes);
    this.isPIIEditPermittedforSSN = this.roleService.isFeatureAccessible(RolePermissionType.SSN, PermissionAccessType.ViewandEdit);
    this.isPIIEditPermittedForDOB = this.roleService.isFeatureAccessible(RolePermissionType.DOB, PermissionAccessType.ViewandEdit);
    }
    this.submitRequestForm = this.fb.group({
      ssn: [this.user.userSSN, [Validators.required, Validators.maxLength(11)]],
      cofirmssn: [this.user.userSSN, [Validators.required, Validators.maxLength(11)]],
      dob: [this.user.userDOB, [Validators.required]],
      isConfirm: [null]
    });
    if(this.user.userName == null){
      this.user.userName = this.user.applicantName;
    }

  }

  clearDate() {
    this.submitRequestForm.get('dob')!.setValue(null);
    this.submitRequestForm.markAsDirty();
  }

  close(state): void {
    this.activeModal.close(state);
  }


  showSSN() {
    this.isShow = !this.isShow;
  }

  getSSNValidation() {
    this.isInValid = this.submitRequestForm.value.cofirmssn.replaceAll('_', '').length < 9 ? true : false;
  }
  // SetResponse() {
  //   this.licenseRenewalRequestDetails = {...this.licenseRenewalRequestDetails.checkEligibilityresponse, licenseRenewalObjList: this.licenseRenewalObjList };
  //   this.licenseRenewalService.licenseRenewalRequestObj(this.licenseRenewalRequestDetails);
  //   this.close(true);
  //  // this.router.navigate(["main-licenses/bulk-licenses-renewal/request-status"]);
  // }

  onSubmit(){
    if(this.submitRequestForm.value.isConfirm){
     if(this.user.userSSN == null && this.user.userDOB == null){
      this.editUserSSN();
      this.editUserDOB();
      this.close(this.submitRequestForm.value);
     }
     else if(this.user.userSSN == null && this.user.userDOB != null){
      this.editUserSSN();
      this.close(this.submitRequestForm.value);
     }
     else if(this.user.userSSN != null && this.user.userDOB == null){
      this.editUserDOB();
      this.close(this.submitRequestForm.value);
     }
    }else{
      this.close(this.submitRequestForm.value);
    }
  }

  editUserSSN() : void{
        let updateUserSSN = {
          contactId: this.user.userId,
          userSSN: this.submitRequestForm.value.ssn,
          tenantId: Number(localStorage.getItem('tenantId')),
          userId: Number(localStorage.getItem('userId'))
        };
        this.contactService.updateUserSSN(updateUserSSN).subscribe((response:any)=>{
          
        });
    }

    editUserDOB(): void{
      let updateUserDOB = {
        contactId: this.user.userId,
        userDOB: this.getFormattedDOB(this.submitRequestForm.value.dob),
        tenantId: Number(localStorage.getItem('tenantId')),
        userId: Number(localStorage.getItem('userId'))
      };
      this.contactService.updateUserDOB(updateUserDOB).subscribe((response:any)=>{
        
      });
  }

  getFormattedDOB(dob: string | { year: number; month: number; day: number }): string {
      if (dob == null) {
        return ''; // or return a default like 'N/A'
      }
      if (typeof dob === 'string') {
        return dob;
      }
    
      return `${dob.month}/${dob.day}/${dob.year}`;
    }

  ngOnDestroy(): void {
    this.subscription.forEach(t => { t.unsubscribe() })
  }

}
